import React from "react";
import { BuilderCtx, SectionFrame } from "./EditContext";
import { REGISTRY } from "./registry";
import { spacingStyle } from "./spacing";

export const SiteRenderer = ({ sections = [], editing = false, selectedId = null, onSelect, onEditText }) => {
    const body = (
        <>
            {sections.filter((s) => editing || s.visible !== false).map((s) => {
                const def = REGISTRY[s.type];
                if (!def) return null;
                const Component = def.component;
                return (
                    <SectionFrame key={s.id} section={s}>
                        <div className={editing && s.visible === false ? "opacity-35" : ""}
                            style={spacingStyle(s.props || {})}>
                            <Component props={s.props || {}} section={s} />
                        </div>
                    </SectionFrame>
                );
            })}
        </>
    );

    if (!editing) return <div className="bg-bg0 text-white">{body}</div>;
    return (
        <BuilderCtx.Provider value={{ editing, selectedId, onSelect: onSelect || (() => {}), onEditText: onEditText || (() => {}) }}>
            <div className="bg-bg0 text-white">{body}</div>
        </BuilderCtx.Provider>
    );
};
